import React from 'react'
import './index.css'

const CancelSubscription = (props) => {
  const { remove, cancel, type } = props
  return (
    <div className='confirm-subscription-removal-container'>
      <div className='center'>
        <p style={{ fontSize: '15px', fontWeight: 'bold', textAlign: 'center' }}>{`Are you sure you want to cancel `}</p>
        <p style={{ fontSize: '15px', marginTop: 10, fontWeight: 'bold', textAlign: 'center' }}>{`the automatic renewal of your subscription?`}</p>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
          <button
            onClick={cancel}
            style={{ margin: '0', width: '45%', backgroundColor: 'gray' }}>No</button>
          <button
            onClick={remove}
            style={{ margin: '0', backgroundColor: '#ff6800', width: '45%', backgroundColor: 'green' }}>Yes</button>
        </div>
      </div>
    </div>
  )
}

export default CancelSubscription